export const darkModeStyles = {
    control: (styles, { isFocused }) => ({
        ...styles,
        minHeight: '46px',
        backgroundColor: 'rgba(34, 38, 45, 0.94)',
        borderColor: isFocused ? 'rgba(59, 162, 166, 0.7)' : 'rgba(255, 255, 255, 0.08)',
        borderRadius: '999px',
        boxShadow: isFocused ? '0 0 0 3px rgba(59, 162, 166, 0.18)' : 'none',
        '&:hover': {
            borderColor: 'rgba(59, 162, 166, 0.48)',
        },
        color: 'white',
        paddingLeft: '8px',
    }),
    menu: (styles) => ({
        ...styles,
        backgroundColor: '#232831',
        color: 'white',
        borderRadius: '20px',
        overflow: 'hidden',
        border: '1px solid rgba(59, 162, 166, 0.16)',
        boxShadow: '0 20px 50px rgba(0, 0, 0, 0.34)',
        marginTop: '6px',
        zIndex: 30,
    }),
    menuPortal: (styles) => ({
        ...styles,
        zIndex: 2000,
    }),
    valueContainer: (styles) => ({
        ...styles,
        padding: '4px 12px',
        gap: '6px',
    }),
    multiValue: (styles) => ({
        ...styles,
        backgroundColor: 'rgba(59, 162, 166, 0.18)',
        borderRadius: '999px',
        border: '1px solid rgba(59, 162, 166, 0.24)',
    }),
    multiValueLabel: (styles) => ({
        ...styles,
        color: 'white',
        fontSize: '12px',
        fontWeight: 600,
    }),
    multiValueRemove: (styles) => ({
        ...styles,
        color: 'white',
        borderRadius: '999px',
        ':hover': {
            backgroundColor: 'rgba(122, 227, 230, 0.18)',
            color: 'white',
        },
    }),
    placeholder: (styles) => ({
        ...styles,
        color: 'rgba(255, 255, 255, 0.62)',
    }),
    singleValue: (styles) => ({
        ...styles,
        color: 'white',
        fontWeight: 600,
    }),
    input: (styles) => ({
        ...styles,
        color: 'white',
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        backgroundColor: 'transparent', // Transparent separator
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        color: 'rgba(255, 255, 255, 0.72)',
        ':hover': {
            color: '#FFFFFF',
        },
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: 'rgba(255, 255, 255, 0.72)',
        ':hover': {
            color: '#3BA2A6',
        },
    }),
    option: (styles, { isFocused, isSelected }) => ({
        ...styles,
        backgroundColor: isSelected
            ? 'rgba(59, 162, 166, 0.24)'
            : isFocused
                ? 'rgba(59, 162, 166, 0.12)'
                : 'transparent',
        color: 'white',
        fontWeight: isSelected ? 600 : 500,
        padding: '12px 16px',
    }),
};